export default "__VITE_ASSET__DvSgalk2__"